var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-select',{staticStyle:{"width":"100px !important"},attrs:{"label":"Page Size","autocomplete":"","disabled":_vm.disabled,"options":_vm.localOptions,"clearable":false,"remove-validation-padding":""},model:{value:(_vm.pageSize),callback:function ($$v) {_vm.pageSize=$$v},expression:"pageSize"}})
}
var staticRenderFns = []

export { render, staticRenderFns }